import { render, staticRenderFns } from "./CorporateContacts.vue?vue&type=template&id=10a05226&scoped=true"
import script from "./CorporateContacts.vue?vue&type=script&lang=js"
export * from "./CorporateContacts.vue?vue&type=script&lang=js"
import style0 from "./CorporateContacts.vue?vue&type=style&index=0&id=10a05226&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a05226",
  null
  
)

export default component.exports